import * as React from 'react';

const SvgReferAFriend: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.764A3 3 0 0116.83 6H19a2 2 0 012 2v11a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h2.17A3 3 0 0112 2.764zM14 6h.003A1 1 0 1013 4.997V6h1zm-3-1v-.003A1 1 0 109.997 6H11V5zm8 3h-4.758l1.354 1.354-1.414 1.414L13 9.586V12h6V8zm-8 4V9.243l-1.525 1.525L8.06 9.354 9.415 8H5v4h6zm0 2v5H5v-5h6zm2 5h6v-5h-6v5z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SvgReferAFriend;
